import { Format } from "../../../../helpers/formatters";
import { ChangeEvent } from "react";

export const states = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']

function formatCPFInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.maskCPFCNPJ(e.target.value);
}

function formatCEPInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.maskCEP(e.target.value);
}

function formatNumberInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.onlyNumber(e.target.value);
}

export default {
    formatCPFInput,
    formatCEPInput,
    formatNumberInput
}